import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'preact/hooks';
import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import ProductCard from 'utils/product-card';
import { edgesToNodes } from 'utils/storefront/format-resource';
import { FreeMode } from 'swiper';

const CollectionGrid = (props) => {
  const storefront = Storefront.getInstance();
  const [products, setProducts] = useState(props.collection.products || []);

  const getCollection = async () => {
    const response = await storefront.request({
      query: queries.collectionGet,
      variables: {
        id: props.collection.id,
        first: 15,
      },
    });

    if (!response.data) {
      // eslint-disable-next-line no-console
      console.error(
        'product-grid/product-grid.js: Storefront API request failed',
        response,
      );
      return [];
    }

    return edgesToNodes(response.data.collection.products, 'product');
  };

  useEffect(() => {
    if (products.length) return;
    getCollection().then((items) => setProducts(items));
  }, []);

  return (
    products.length && (
      <Swiper
        id="collection-grid"
        className="max-w-container mx-auto"
        slidesPerView="auto"
        spaceBetween={4}
        modules={[FreeMode]}
        freeMode={true}
        data-target="collection-slider"
        breakpoints={{
          768: {
            slidesPerView: 15,
          },
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id} className="!w-[247px]">
            <ProductCard key={product.id} product={product} {...props} />
          </SwiperSlide>
        ))}
      </Swiper>
    )
  );
};

export default CollectionGrid;
